import type { CppRateCard } from '~/types/costPerPoint';

/** The minimum shape needed to format a rate card's CPP for display. */
type CppFormattable = Pick<CppRateCard, 'cppMinCents' | 'cppMaxCents' | 'pricingModel'>;

/**
 * Formats a rate card's CPP for display: a single value for a FLAT card (or a degenerate
 * TIERED card whose min and max happen to match), otherwise a min–max range. CPP is in cents,
 * so values are suffixed with `c` (fractional cents such as `0.5c` are valid and preserved).
 *
 * Shared by the rate-card list and the timeline so both always render CPP identically.
 *
 * @param card - The rate card (or any object carrying its cpp min/max cents and pricing model).
 * @returns The formatted CPP string, e.g. `"5c"` or `"5c - 8c"`.
 */
export function formatCpp(card: CppFormattable): string {
  if (card.pricingModel === 'FLAT' || card.cppMinCents === card.cppMaxCents) {
    return `${card.cppMinCents}c`;
  }
  return `${card.cppMinCents}c - ${card.cppMaxCents}c`;
}
